export default function actionPersonaMutator( type, plugin, molten ) {

  if ( type !== 'Action' ) {
    return plugin
  }
  const { id } = plugin

  if ( id === 'molten.export' ) {
    return {
      ...plugin,
      handles : ( cxt ) => {
        const objectType = cxt?.clientProps?.objectType
        if ( objectType === 'job' || objectType === 'jobItem' ) {
          return false
        }
        return plugin.handles( cxt )
      }
    }
  }
  
  return plugin
}
